import { render, staticRenderFns } from "./person_detail.vue?vue&type=template&id=6bbcea5e"
import script from "./person_detail.vue?vue&type=script&lang=js"
export * from "./person_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports